import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { useMainStore } from '@/stores/main-store'
import { storeToRefs } from 'pinia'
import FluentMegaphoneLoud28Filled from '@/components/icons/FluentMegaphoneLoud28Filled.vue'
import Confirmation from '@/components/Confirmation.vue'
import type { ConfirmationType } from '@/misc/custom-types'
import { HttpPost } from '@/services/Service'
import type CustomWindow from '@/misc/custom-window'

declare const window: CustomWindow


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileToolbar',
  setup(__props) {

const mainStore = useMainStore()

const {
  user,
  profileToolbarVisible,
  companyName,
} = storeToRefs(mainStore)

// Only show the clear workflow button for super admins
// in develop and local environments
const showWorkflowClearBtn = computed(() => {
  return user.value.is_super_admin && ['develop', 'local'].includes(window.APP_ENV)
})

const confirm = ref<ConfirmationType>()

const clearCurrentWorkflow = async () => {
  const result = await confirm.value?.open({
    showSwalType: false,
    message: 'Weet je zeker dat je de administratie wilt legen?',
    submitText: 'Legen',
    cancelText: 'Annuleren',
  })

  if (!result?.value) return

  await HttpPost('/api/v1/workflow/clear')
    .then(() => location.reload())
}

return { __sfc: true,mainStore, user, profileToolbarVisible, companyName, showWorkflowClearBtn, confirm, clearCurrentWorkflow, FluentMegaphoneLoud28Filled, Confirmation }
}

})